"use client";

import { Checkbox } from "../ui/checkbox";
import type { ShortenUrlControlProps } from "./shorten-url-control.types";

/** Presentational control shared by link-only, bulk-job and generated-content copies. */
export function ShortenUrlControl(props: ShortenUrlControlProps) {
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-3">
        <Checkbox
          label={
            <span className="text-[10px] font-normal leading-tight">
              {props.label}
            </span>
          }
          checked={props.checked}
          onChange={(event) =>
            props.onCheckedChange(event.currentTarget.checked)
          }
        />
        {props.isLoading && (
          <span role="status" className="text-xs text-[#667085]">
            {props.loadingLabel}
          </span>
        )}
      </div>
      {props.error && (
        <div
          role="alert"
          className="flex flex-wrap items-center gap-2 text-xs text-red-700"
        >
          <span>{props.error}</span>
          <button
            type="button"
            onClick={props.onRetry}
            className="font-semibold underline"
          >
            {props.retryLabel}
          </button>
        </div>
      )}
    </div>
  );
}
